import React, { useState } from "react";

function AccordionItem({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="mb-1 border rounded-md text-[#388e3c]">
      <button
        className="w-full text-left px-4 py-3 font-medium flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{title}</span>
        <span>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && <div className="px-4 pb-3">{children}</div>}
    </div>
  );
}

export default function D01({ faqItem }) {
  return (
    <section id="faqDynamicAccordion">
      <div className="container m-auto pt-[10px] pb-[1rem] px-[1rem] sm:px-[2rem] lg:px-[3rem]">
        <div>
          {faqItem?.advanceData?.data?.length && (
            <div className="flex flex-col gap-[1rem]">
              {faqItem.advanceData.data.map((item, index) => (
                <AccordionItem key={index} title={item?.title}>
                  {item?.desci && (
                    <div>
                      <span
                        dangerouslySetInnerHTML={{ __html: item.desci }}
                      ></span>
                    </div>
                  )}
                </AccordionItem>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
